import { useEffect, useState } from "react";
import { fetchProducts } from "../lib/api";

// Module-level cache so we only hit the API once per session.
let _cache = null;
let _pending = null;
const _subscribers = new Set();

const notify = () => {
  for (const fn of _subscribers) fn(_cache);
};

const loadOnce = () => {
  if (_cache) return Promise.resolve(_cache);
  if (_pending) return _pending;
  _pending = fetchProducts()
    .then((products) => {
      _cache = products;
      _pending = null;
      notify();
      return products;
    })
    .catch((err) => {
      _pending = null;
      throw err;
    });
  return _pending;
};

export function useProducts() {
  const [state, setState] = useState({
    products: _cache || [],
    loading: !_cache,
    error: null,
  });

  useEffect(() => {
    let active = true;
    const sub = (products) => {
      if (active) queueMicrotask(() => setState({ products, loading: false, error: null }));
    };
    _subscribers.add(sub);
    if (!_cache) {
      loadOnce().catch((err) => {
        if (active) queueMicrotask(() => setState({ products: [], loading: false, error: err }));
      });
    } else {
      queueMicrotask(() => setState({ products: _cache, loading: false, error: null }));
    }
    return () => {
      active = false;
      _subscribers.delete(sub);
    };
  }, []);

  return state;
}
